import { render, staticRenderFns } from "./D006.vue?vue&type=template&id=6df3cdc2&scoped=true&"
import script from "./D006.vue?vue&type=script&lang=js&"
export * from "./D006.vue?vue&type=script&lang=js&"
import style0 from "./D006.vue?vue&type=style&index=0&id=6df3cdc2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df3cdc2",
  null
  
)

export default component.exports